import { FormDataPersonalInformation } from ".";
import { getPersonFormEmptyValues } from "../FormPartialPerson/emptyValues";

export const emptyValues: FormDataPersonalInformation = {
  person: getPersonFormEmptyValues()
};
